// extracted by mini-css-extract-plugin
export default {"container":"toasts_container__h4kbr","toast":"toasts_toast__2Iggn","title":"toasts_title__x871u","close":"toasts_close__2ZPBe"};